import React from 'react';

export function Fish() {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M24 8C24.5523 8 25 7.55228 25 7C25 6.44772 24.5523 6 24 6C23.4477 6 23 6.44772 23 7C23 7.55228 23.4477 8 24 8Z"
                className="fill-primary"
            />
            <path
                d="M25.9998 2C21.7578 2.00476 17.6909 3.692 14.6913 6.69155C11.6918 9.6911 10.0046 13.758 9.99979 18V20H2.99979C2.80204 20 2.60874 20.0587 2.44433 20.1686C2.27992 20.2785 2.15178 20.4346 2.07611 20.6173C2.00044 20.8 1.98064 21.0011 2.0192 21.195C2.05777 21.389 2.15298 21.5671 2.29279 21.707L10.2928 29.707C10.4326 29.8468 10.6108 29.942 10.8048 29.9806C10.9987 30.0192 11.1997 29.9993 11.3824 29.9237C11.5651 29.848 11.7213 29.7199 11.8312 29.5555C11.9411 29.391 11.9997 29.1978 11.9998 29V22H13.9998C18.2418 21.9952 22.3087 20.308 25.3082 17.3084C28.3078 14.3089 29.995 10.242 29.9998 6V2H25.9998ZM9.99979 26.586L5.41379 22H9.99979V26.586ZM11.9998 20V18C12 14.3896 13.401 10.9202 15.9078 8.322L23.6778 16.092C21.0796 18.5988 17.6101 19.9997 13.9998 20H11.9998ZM27.9998 6C27.9996 9.12137 26.9501 12.152 25.0198 14.605L17.3948 6.98C19.8477 5.04972 22.8784 4.00017 25.9998 4H27.9998V6Z"
                className="fill-primary"
            />
        </svg>
    );
}
